function n() {
  window.nostojs = window.nostojs ?? function(o) {
    (window.nostojs.q = window.nostojs.q ?? []).push(o);
  };
}
async function s(o) {
  return window.nostojs(o);
}
let t = null;
typeof window < "u" && (n(), s((o) => {
  t = o.internal.getSettings();
}));
function d() {
  return t;
}
async function u(o, i, w) {
  if (!window.Nosto?.addSkuToCart)
    throw new Error("Nosto addSkuToCart function is not available");
  await window.Nosto.addSkuToCart(o, i, w);
}
typeof window < "u" && n();
export {
  u as C,
  d as i,
  s
};
